const bankAccounts = {
  'bankAccounts.dailyLimits': 'daily limits',
  'bankAccounts.total': 'total',
  'bankAccounts.used': 'used',
  'bankAccounts.available': 'Available limit',
  'bankAccounts.limits': 'Daily limits',
  'bankAccounts.bankSlips': 'Bank slips',
  'bankAccounts.Valor máximo de retirada P2P': 'Maximum P2P withdraw',
  'bankAccounts.Valor máximo de retirada P2P por dia':
    'Maximum P2P withdraw per day',
  'bankAccounts.Valor máximo de retirada TEF': 'Maximum TEF withdraw',
  'bankAccounts.Valor máximo de retirada TEF por dia':
    'Maximum TEF withdraw per day',
  'bankAccounts.Valor máximo de retirada TED': 'Maximum TED withdraw',
  'bankAccounts.Valor máximo de retirada TED por dia':
    'Maximum withdrawal TED/TEF same ownership per day',
  'bankAccounts.Valor máximo de compras': 'Maximum spending',
  'bankAccounts.Valor máximo de compras por dia':
    'Maximum spending per day (transfers, TED/TEF other ownership)',
  'bankAccounts.Valor máximo de cartões Pismo':
    'Maximum amount for Pismo cards',
  'bankAccounts.Valor máximo de cartões Pismo por dia':
    'Maximum spending with Pismo cards per day, up to the maximum spending available per day',
  'bankAccounts.Valor máximo de outros cartões':
    'Maximum amount for other cards',
  'bankAccounts.Valor máximo de outros cartões por dia':
    'Maximum spending with other cards per day, up to the maximum spending available per day',
  'bankAccounts.Valor máximo de solicitação por pagamento por dia':
    'Maximum amount request for payment per day',
  'bankAccounts.Valor máximo por boleto': 'Maximum amount per bank slip',
  'bankAccounts.Valor máximo de boletos por mês':
    'Maximum amount of bank slips per month',
  'bankAccounts.Valor mínimo por boleto': 'Minimum amount per bank slip',
  'bankAccounts.Número de boletos por dia': 'Maximum bank slips per day',
  'bankAccounts.paymentRequests': 'Payment requests',
  'bankAccounts.Valor máximo de solicitação por pagamento para PF':
    'Maximum to charge other person clients',
  'bankAccounts.Valor máximo de solicitação por pagamento para PJ':
    'Maximum to charge other company clients',
  'bankAccounts.Valor máximo de mesma titularidade TED por dia':
    'Maximun withdraw TED/TEF same ownership per day',
};

export default bankAccounts;
